module.exports = __webpack_public_path__ + "static/media/facethegorillas.d76fe11e.jpeg";